<script lang="ts">
	import { ProjectorMenuController } from "../../ProjectorMenuController.svelte"
	import CalibrationList from "./calibration-list/CalibrationList.svelte"
	import { Toast } from "toaster"
	import { hideMinimizedCalibration } from "../../../../reusable/overlays/calibration/calibration-minimized"
	import { openCalibrationOverlay } from "../../../../reusable/overlays/calibration"
	import { mobileScrollFade } from "responsive"
	import DeviceCalibrationInfo from "./DeviceCalibrationInfo.svelte"
	import { Reactivity } from "luxedo-reactivity"
	import DeviceCalibrationPreview from "./DeviceCalibrationPreview.svelte"
	import { CalibrationController } from "../../../../reusable/overlays/calibration/CalibrationController.svelte"

	let device = $derived(ProjectorMenuController.ctx.device)

	$effect.pre(() => {
		Reactivity.useProps(device, ["isCalibrated"])
	})

	let isCalibrated = $derived(Reactivity.propOf(device, "isCalibrated"))

	function beginCalibration() {
		if (!device.isOnline) return Toast.error("Device must be online to calibrate!")

		// reset if existing
		if (
			device.id in CalibrationController.runs &&
			CalibrationController.runs[device.id].step === 1
		) {
			hideMinimizedCalibration(device)
			CalibrationController.reset(device.id)
		}

		openCalibrationOverlay(device)
	}
</script>

<div class="calibration-menu projector-menu" use:mobileScrollFade>
	<DeviceCalibrationInfo {beginCalibration} {device} {isCalibrated} />
	<DeviceCalibrationPreview {device} />
	{#if isCalibrated}
		<CalibrationList {device} />
	{/if}
</div>

<style>
	.calibration-menu {
		width: 100%;
		flex-grow: 1;
		overflow-y: hidden;
		display: flex;
		justify-content: space-between;
		flex-direction: column;
	}
</style>
